import styles from "./filters.module.css";
import { FilterIcon } from "ui/icons";
import AllSiteRegionToggle from "ui/general/all_region_site_toggle";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export default function Filters(props) {
  const { params, setSearchParams, sitesRegions } = props;

  return (
    <div className={styles.filter_wrapper}>
      <FilterIcon />
      <div className={styles.selector}>
        <AllSiteRegionToggle
          mode={params.filter}
          onClick={(filter) => setSearchParams({ ...params, filter })}
          enableRegion={sitesRegions?.regions?.length}
        />
      </div>
      {params.filter === "region" || (!params.filter && sitesRegions?.regions?.length) ? (
        <div className={styles.drop_down}>
          <Select
            value={params.region || 0}
            sx={{
              fontSize: 14,
              minWidth: 200,
              height: 30,
              padding: 0,
              alignSelf: "center",
            }}
            onChange={(e) => {
              setSearchParams({ ...params, region: e.target.value });
            }}
          >
            {sitesRegions?.regions?.map((r) => (
              <MenuItem key={r.id} value={r.id}>
                {r.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      ) : null}
      {params.filter === "site" ? (
        <div className={styles.drop_down}>
          <Select
            value={params.site || 0}
            sx={{
              fontSize: 14,
              minWidth: 200,
              height: 30,
              padding: 0,
              alignSelf: "center",
            }}
            onChange={(e) => {
              setSearchParams({ ...params, site: e.target.value });
            }}
          >
            {sitesRegions?.sites?.map((r) => (
              <MenuItem key={r.id} value={r.id}>
                {`${r.name} ${r.code !== 0 ? `(${r.code})` : ""}`}
              </MenuItem>
            ))}
          </Select>
        </div>
      ) : null}
    </div>
  );
}
